@import "~vanilla-cookieconsent/dist/cookieconsent.css";

physiogroup-cookiehint {
    display: block;
}
